import React from 'react';
import styled from 'styled-components';
import tag from 'clean-tag';
import { themeGet } from 'styled-system';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import theme from './style/theme';
import ThemeProvider from './style/ThemeProvider';
import Home from './Home';
import About from './About';
import News from './News';
import Play from './Play';
import Resources from './Resources';
import Contact from './Contact';
import NationalTeams from './NationalTeams';
import Support from './Support';
import GlobalHeader from './GlobalHeader';
import MainNav from './MainNav';
import ScrollToTop from './ScrollToTop';
import { Box, Flex } from './Layout';
import footerBanner from './images/footer-banner.png';
import { Link } from './Typography';

const Page = styled(Box)`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  line-height: ${themeGet('lineHeights.loose')};
`;

const Main = styled(Box)`
  flex: 1;
`;

const Footer = styled(Box)`
  border-top: 2px solid ${themeGet('colors.brand.primary')};
  background: white;
  padding: 20px;
`;

const FooterBanner = styled(tag.img)`
  width: 90%;
`;

const App = () => (
  <Router>
    <ScrollToTop>
      <ThemeProvider theme={theme}>
        <Page>
          <GlobalHeader />
          <MainNav />
          <Main m={10}>
            <Route exact path="/" component={Home} />
            <Route path="/news" component={News} />
            <Route path="/about" component={About} />
            <Route path="/play" component={Play} />
            <Route path="/resources" component={Resources} />
            <Route path="/contact" component={Contact} />
            <Route path="/support" component={Support} />
            <Route path="/national-teams" component={NationalTeams} />
          </Main>

          <Footer>
            <Flex justifyContent="center" alignItems="center">
              <Box>
                <FooterBanner src={footerBanner} alt="Blind sports Australia Advertising" />
              </Box>
              <Box>
                <h4>Contact Australian Blind Football</h4>
                <p>
                  <Link
                    href="mailto:football@blindsportsaustralia.com.au?Subject=Website%20Query"
                    target="_top"
                    aria-label="Email Blind Football Australia"
                  >
                    football@blindsportsaustralia.com.au
                  </Link>
                </p>
                <p>Facebook: @ausblindfootball</p>
              </Box>
            </Flex>
          </Footer>
        </Page>
      </ThemeProvider>
    </ScrollToTop>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js